import './src/polyfills.ts';
import '@angular/localize/init';
import '@formatjs/intl-durationformat/polyfill';